import { render } from "./investment.vue?vue&type=template&id=020aeab6&scoped=true"
import script from "./investment.vue?vue&type=script&lang=js"
export * from "./investment.vue?vue&type=script&lang=js"

import "./investment.vue?vue&type=style&index=0&id=020aeab6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-020aeab6"

export default script